<template>
  <span :class="spinnerClasses">
    <span class="spinner-animated-ball" />
    <span class="spinner-animated-ball" />
    <span class="spinner-animated-ball" />
    <span class="spinner-animated-ball" />
  </span>
</template>

<script>
  export default {
    name: 'SpinnerAnimated',
    props: {
      color: {
        type: String,
        default: '',
      },
      size: {
        type: String,
        default: '',
      },
    },
    computed: {
      spinnerClasses() {
        const classes = ['spinner-animated'];

        if (this.color) {
          classes.push(`spinner-animated-color-${this.color}`);
        }

        if (this.size) {
          classes.push(`spinner-animated-size-${this.size}`);
        }

        return classes;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  $ball-size: $gutter-small;
  $ball-size-small: $gutter-smallest;

  .spinner-animated {
    align-self: center;
    display: inline-block;
    height: $ball-size;
    position: relative;
    vertical-align: middle;
    width: $ball-size * 4;

    &.spinner-animated-size-small {
      height: $ball-size-small;
      width: $ball-size-small * 4;
    }
  }

  .spinner-animated-ball {
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
    background-color: $green;
    border-radius: 50%;
    height: $ball-size;
    margin-top: $ball-size * -0.5;
    position: absolute;
    top: 50%;
    width: $ball-size;

    .spinner-animated-size-small & {
      height: $ball-size-small;
      margin-top: $ball-size-small * -0.5;
      width: $ball-size-small;
    }

    .spinner-animated-color-gray & {
      background-color: $gray;
    }

    .spinner-animated-color-gray-light & {
      background-color: $gray-light;
    }

    .spinner-animated-color-white & {
      background-color: $white;
    }

    .spinner-animated-color-blue & {
      background-color: $blue;
    }

    @keyframes spinner-one {
      0% { transform: scale(0) }
      100% { transform: scale(1) }
    }

    @keyframes spinner-two {
      0% { transform: translate(0, 0) }
      100% { transform: translate($ball-size * 1.5, 0) }
    }

    @keyframes spinner-two-small {
      0% { transform: translate(0, 0) }
      100% { transform: translate($ball-size-small * 1.5, 0) }
    }

    @keyframes spinner-three {
      0% { transform: scale(1) }
      100% { transform: scale(0) }
    }

    &:nth-child(1) {
      left: 0;
      animation: spinner-one 0.5s infinite;
    }

    &:nth-child(2) {
      left: 0;
      animation: spinner-two 0.5s infinite;

      .spinner-animated-size-small & {
        animation: spinner-two-small 0.5s infinite;
      }
    }

    &:nth-child(3) {
      left: $ball-size * 1.5;
      animation: spinner-two 0.5s infinite;

      .spinner-animated-size-small & {
        left: $ball-size-small * 1.5;
        animation: spinner-two-small 0.5s infinite;
      }
    }

    &:nth-child(4) {
      left: $ball-size * 3;
      animation: spinner-three 0.5s infinite;

      .spinner-animated-size-small & {
        left: $ball-size-small * 3;
      }
    }
  }

</style>
